
import { Timeline } from 'antd';
import { useEffect, useState } from 'react';

const EducationTimeLine = () => {
    const [width, setWidth] = useState(window.innerWidth);
    const [timelineMode, setTimelineMode] = useState("");

    useEffect(() => {
        window.addEventListener("resize", () => setWidth(window.innerWidth));
        // console.log(width);
        // console.log("resize detected");

        if (width <= 768) setTimelineMode("");
        else setTimelineMode("alternate");

        return () => {
            window.removeEventListener("resize", () => setWidth(window.innerWidth));
        };
    }, [width]);

    return (
        <div className='dark:bg-cDarkBG2/20 bg-white/20 backdrop-blur-[5px] border border-white/10 sm:rounded-[32px] rounded-[26px] px-5 pt-5 w-full'>
            <Timeline
                style={{
                    backgroundColor: 'transparent',
                }}
                // style={{ width: '100%' }}
                // className='w-full'
                mode={timelineMode}
                items={[
                    {
                        children: <MainTitle
                            timeStamp='2016-2021'
                            title='Bachelor of Science'
                            description={
                                <div className='space-y-1 pt-1'>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'>Inst:</span> <span>North South University (NSU)</span>
                                    </div>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'>Major:</span> <span> Computer Science and Engineering</span>
                                    </div>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'>Thesis:</span> <span>Pedestrian Road cross prediction for Autonomous Car in terms of Dhaka city</span>
                                    </div>
                                </div>
                            }
                        />,

                        color: 'green',
                    },
                    {
                        children: <MainTitle
                            timeStamp='2015'
                            title='Higher Secondary'
                            description={
                                <div className='space-y-1 pt-1'>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'>Inst:</span> <span>Joypurhat GOVT. College</span>
                                    </div>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'>Group:</span> <span> Science</span>
                                    </div>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'>GPA:</span> <span>5.00 out of 5.00</span>
                                    </div>
                                </div>
                            }
                        />,

                        color: 'green',
                    },
                    {
                        children: <MainTitle
                            timeStamp='2013'
                            title='Secondary'
                            description={
                                <div className='space-y-1 pt-1'>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'>Inst:</span> <span>Ramdeo Bazla GOVT. High School, Joypurhat</span>
                                    </div>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'>Group:</span> <span> Science</span>
                                    </div>
                                    <div className='text-xs md:text-sm'>
                                        <span className='font-medium'>GPA:</span> <span>5.00 out of 5.00</span>
                                    </div>
                                </div>
                            }
                        />,

                        color: 'green',
                    },

                ]}
            />
        </div>
    )
}

export default EducationTimeLine


const MainTitle = ({ title = "", timeStamp = '', subTItle = '', description = "" }) => {
    return (
        <div>
            {timeStamp ? <div className='text-xs md:text-sm dark:text-cDarkText text-gray-400'>{timeStamp}</div> : null}
            <div className='font-semibold text-base dark:text-cDarkText2 text-gray-600'>{title}</div>
            {subTItle ? <div className='dark:text-cDarkText text-gray-400'>{subTItle}</div> : null}
            {description ? <div className='dark:text-cDarkText text-gray-400'>{description}</div> : null}
        </div>
    )
}